import React, { FC } from 'react';
import { AutomationContactType } from '@dev/ee-api/ee-api-models';
import { Pagination } from '@dev/ee-components';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { safelyDecodeBase64Url } from '@dev/ee-tools';
import { GetAutomationContactsStart, getAutomationStore } from '@/store/automations/actions';
import { GetAutomationContactsParams } from '@/services/ElasticApi';
import { calculateOffset } from '@/services/tools/handleUrlParams';
import { DEFAULT_PER_PAGE_COUNT } from '@/services/constants';

const ContactsPagination: FC = (): JSX.Element => {
    const { loadingContactsList, contactsListPagination, contactsTotalCount } = useSelector(getAutomationStore);
    const dispatch = useDispatch();

    const totalCount = loadingContactsList ? 0 : contactsTotalCount;
    const activePage = contactsListPagination?.page;

    const urlParams: { name: string; recipientsType: AutomationContactType } = useParams();

    const changePage = (page: number, perPage: number): void => {
        const params: GetAutomationContactsParams = {
            offset: calculateOffset(page, perPage),
            limit: perPage,
            name: safelyDecodeBase64Url(urlParams.name),
            type: urlParams.recipientsType,
            from: contactsListPagination?.from,
            to: contactsListPagination?.to,
        };

        dispatch(GetAutomationContactsStart(params));
    };

    return (
        <Pagination
            dataLength={totalCount}
            perPage={contactsListPagination?.perPage ?? DEFAULT_PER_PAGE_COUNT}
            activePage={activePage}
            handlePaginationChange={changePage}
        />
    );
};

export default ContactsPagination;
